module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_x_red-7b137ab913693e1c6b78656048e731aa.svg";